import { render, staticRenderFns } from "./clickContact.vue?vue&type=template&id=477dfabd&scoped=true"
import script from "./clickContact.vue?vue&type=script&lang=js"
export * from "./clickContact.vue?vue&type=script&lang=js"
import style0 from "./clickContact.vue?vue&type=style&index=0&id=477dfabd&prod&scoped=true&media=screen%2C%20projection&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "477dfabd",
  null
  
)

export default component.exports